import {
  styled,
  Grid as GridBase,
  Box,
  Typography,
  Paper,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Tooltip,
} from "@mui/material";
import { tooltipClasses } from "@mui/material/Tooltip";

export const GridContainer = styled((props) => (
  <GridBase {...props} container />
))`
  &.MuiGrid-container {
    margin: ${(props) => props.margin || "0"};
    padding: ${(props) => props.padding || "0"};
  }
`;

export const MonthlyReportFormRootArea = styled((props) => (
  <GridContainer {...props} />
))``;

export const GridItem = styled((props) => <GridBase {...props} item />)`
  &.MuiGrid-item {
    display: flex;
    flex-direction: ${(props) => props.flexDirection || "column"};
    margin: ${(props) => props.margin || "0"};
    padding: ${(props) => props.padding || "0"};
  }
`;

export const DataCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(3),
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  border: `1px solid ${theme.palette.divider}`,
  transition: "all 0.3s ease",
  "&:hover": {
    boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
    transform: "translateY(-2px)",
  },
}));

export const DataCardHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginBottom: theme.spacing(2),
  paddingBottom: theme.spacing(1),
  borderBottom: `2px solid ${theme.palette.primary.main}`,
}));

export const DataCardTitle = styled(Typography)(({ theme }) => ({
  fontSize: "1.1rem",
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginLeft: theme.spacing(1),
}));

export const DataCardContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

export const DataItem = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: theme.spacing(1, 0),
  borderBottom: `1px solid ${theme.palette.divider}`,
  "&:last-child": {
    borderBottom: "none",
  },
}));

export const DataLabel = styled(Box)(({ theme }) => ({
  fontSize: "0.9rem",
  fontWeight: 500,
  color: theme.palette.text.secondary,
  textTransform: "uppercase",
  letterSpacing: "0.5px",
}));

export const DataValue = styled(Box)(({ theme }) => ({
  fontSize: "1.1rem",
  fontWeight: 600,
  color: theme.palette.text.primary,
  textAlign: "right",
}));

export const SummaryGrid = styled(GridContainer)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const SummaryItem = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(2),
  backgroundColor: theme.palette.blokko.tableRow,
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.divider}`,
}));

export const SummaryLabel = styled(Typography)(({ theme }) => ({
  fontSize: "0.875rem",
  fontWeight: 500,
  color: theme.palette.text.secondary,
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  marginBottom: theme.spacing(0.5),
}));

export const SummaryValue = styled(Typography)(({ theme, positive }) => ({
  fontSize: "1.25rem",
  fontWeight: 700,
  color: positive
    ? theme.palette.success.main
    : positive === false
    ? theme.palette.error.main
    : theme.palette.text.primary,
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: "1.25rem",
  fontWeight: 700,
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(3),
}));

export const ReportTable = styled(Table)(({ theme }) => ({
  width: "100%",
  "& .MuiTableCell-root": {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1.5, 2),
  },
  "& .MuiTableHead-root .MuiTableCell-root": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 700,
    fontSize: "0.875rem",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
}));

export const ReportTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: theme.palette.blokko.taglineMist,
  },
  "&:hover": {
    backgroundColor: theme.palette.blokko.tableRowHover,
  },
}));

export const AmountCell = styled(TableCell)(({ theme, positive }) => ({
  fontWeight: 600,
  color: positive
    ? theme.palette.success.main
    : positive === false
    ? theme.palette.error.main
    : theme.palette.text.primary,
  textAlign: "right",
}));

export const TooltipInfo = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: `1px solid ${theme.palette.divider}`,
  },
}));